export default "__VITE_ASSET__9AJ2eVJI__"